import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { call, cancel, takeEvery } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
  ProduktRequested,
} from '@ps20-frontend/shop-integration-redux';
import { App, IAnimalValueLabelElement } from '@ps20-frontend/frontend-models';
import { DogBreed, Domaene, Tierrassen as TierrassenBff } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';

export const URL_TIERRASSENLISTE = '/privatschutz/api/tierrassen';
export const URL_TIERRASSENLISTE_THH = URL_TIERRASSENLISTE + '/thh';


export enum TierrassenListRequestActions {
  TIERRASSENLISTE_REQUEST_SUCCESSFUL = 'TIERRASSENLISTE_REQUEST_SUCCESSFUL',
  THH_TIERRASSENLISTE_REQUEST_SUCCESSFUL = 'THH_TIERRASSENLISTE_REQUEST_SUCCESSFUL',
  TIERRASSENLISTE_REQUEST_FAILED = 'TIERRASSENLISTE_REQUEST_FAILED',
}

const TKV_APPS = [App.TKV, App.TKV_V2];
const THH_APPS = [App.THH_PFERD, App.THH_HUND];

export function* watchTierrassenListRequest(): SagaIterator {
  yield takeEvery(GlobalActions.PRODUKT_REQUESTED, safeSaga(getTierrassenListSaga, App.SHOP));
  yield takeEvery(
    TierrassenListRequestActions.TIERRASSENLISTE_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP),
  );
  yield takeEvery(
    TierrassenListRequestActions.THH_TIERRASSENLISTE_REQUEST_SUCCESSFUL,
    safeSaga(thhSuccessCallback, App.SHOP),
  );
}

export function* getTierrassenListSaga(action: GlobalAction<ProduktRequested>): SagaIterator {
  if (action.payload.catalogsProvided) {
    return yield cancel();
  }
  if (!(THH_APPS.concat(TKV_APPS)).includes(action.payload.appId)) {
    return yield cancel();
  }
  const globalPut = GlobalPut.getInstance();
  const isTkvApp = TKV_APPS.includes(action.payload.appId);
  return yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP,
      method: HTTP_METHOD.GET,
      body: '',
      url: isTkvApp ? URL_TIERRASSENLISTE : URL_TIERRASSENLISTE_THH,
      successEvent: isTkvApp
        ? TierrassenListRequestActions.TIERRASSENLISTE_REQUEST_SUCCESSFUL
        : TierrassenListRequestActions.THH_TIERRASSENLISTE_REQUEST_SUCCESSFUL,
      errorEvent: TierrassenListRequestActions.TIERRASSENLISTE_REQUEST_FAILED,
    }),
  );
}

export function* successCallback(successAction: AnyAction): SagaIterator {
  const tierrassenResponse: TierrassenBff = successAction.payload;
  const hunderassenListe = getValueLabelListeOfBffTierassenlist(tierrassenResponse.hunderassen);
  const pferderassenListe = getValueLabelListeOfBffTierassenlist(tierrassenResponse.pferderassen);
  const katzenrassenListe = getValueLabelListeOfBffTierassenlist(tierrassenResponse.katzenrassen);

  const globalPut = GlobalPut.getInstance();

  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().hunderassenListeRetrieved(hunderassenListe),
  );
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().pferderassenListeRetrieved(pferderassenListe),
  );
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().katzenrassenListeRetrieved(katzenrassenListe),
  );
}

export function* thhSuccessCallback(successAction: AnyAction): SagaIterator {
  const tierrassenResponse: TierrassenBff = successAction.payload;
  const hunderassenListe = getValueLabelListeOfBffTierassenlist(tierrassenResponse.hunderassen);
  const pferderassenListe = getValueLabelListeOfBffTierassenlist(tierrassenResponse.pferderassen);

  const globalPut = GlobalPut.getInstance();

  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().thhHunderassenListeRetrieved(hunderassenListe),
  );
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().thhPferderassenListeRetrieved(pferderassenListe),
  );
}

function getValueLabelListeOfBffTierassenlist(
  tierrassenListeBff: Array<Domaene | DogBreed>,
): Array<IAnimalValueLabelElement> {
  const result = tierrassenListeBff.map(elem => {
    let returnObject: IAnimalValueLabelElement = {
      label: elem.text,
      value: elem.wert,
    };
    if('motherBreed' in elem && elem.motherBreed != null ){
      returnObject = {
        ...returnObject,
        motherBreed: {
          label: (elem as DogBreed).motherBreed.text,
          value: (elem as DogBreed).motherBreed.wert,
        }
      };
    }
    return returnObject;
  });
  return result.sort((a, b) => a.label.localeCompare(b.label));
}
